__webpack_require__.p = "/kricketot-counter/";